import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';



@Injectable()
export class DailyWageSetService {
    constructor(
        private httpService: HttpService) { }

    //获取日工资设置列表
    getDirectSubUser(pars) {
        let url = AppConfig.GetProdUrl() + '/Team/GetDirectSubUser';
        return this.httpService.get(url, pars);
    }
    //获取指定用户的日工资比例列表
    getDailyWageRules(userName) {
        let param = "userName=" + userName;
        let url = AppConfig.GetProdUrl() + '/Team/GetDailyWageRules?' + param;
        return this.httpService.get(url);
    }
    //添加日工资比例
    addDailyWagesRules(param) {
        let url = AppConfig.GetProdUrl() + "/Team/AddDailyWageRules";
        return this.httpService.post(url, param);
    }
    //获取日工资配置
    getDailyWageSetting() {
        let url = AppConfig.GetProdUrl() + "/Team/GetDailyWageSettings";
        return this.httpService.get(url);
    }
}





// WEBPACK FOOTER //
// ./src/services/dailywageset.service.ts